import styled from "styled-components";

export const InviteUsersContainer = styled.div`
  padding-inline: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 100px;
`;

export const InviteDescription = styled.p`
  margin: 24px 0;
  font-family: ${(props) => props.theme.typography?.body?.regular?.family || props.theme.fonts?.family?.inter || "Inter"};
  font-weight: ${(props) => props.theme.typography?.body?.regular?.weight || 400};
  font-size: ${(props) => props.theme.typography?.body?.regular?.size || "16px"};
  line-height: 20px;
  letter-spacing: 0;
  color: ${(props) => props.theme.colors?.davysGrey || props.theme.colors?.neutralDark || "#5C5C5C"};
`;

export const BottomNavigatorWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 60px;
  right: 0;
  z-index: 1000;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  border-top: 1px solid ${(props) => props.theme?.colors?.greySix || "rgba(0,0,0,0.04)"};
  padding: 16px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
